





































































































import Vue, { PropType } from 'vue';

import {
  IQuote,
  IQuotePackage,
  IQuotePackageDocumentData,
  QuotePackageSectionEnum
} from '@/models';

import QuoteDocumentPackageBuilderPDFViewer from '@/components/quotes/QuoteDocumentPackageBuilderPDFViewer.vue';
import QuoteDetailCard from './QuoteDetailSummaryCard.vue';
import NoDataAvailablePlaceholder from '@/components/common/NoDataAvailablePlaceholder.vue';
import QuoteDocumentPackageBuilderSideMenu from '@/components/quotes/QuoteDocumentPackageBuilderSideMenu.vue';

interface Options extends InstanceType<typeof Vue> {
  $refs: {
    quoteDocumentPackageBuilderSideMenu: InstanceType<
      typeof QuoteDocumentPackageBuilderSideMenu
    >;
  };
}

export interface IDocumentSections {
  title: string;
  package_documents: IQuotePackageDocumentData[];
  section: QuotePackageSectionEnum | null;
}

export default Vue.extend<Options>({ functional: false }).extend({
  name: 'QuoteDocumentPackageBuilder',

  props: {
    quotePackage: [Object] as PropType<IQuotePackage>
  },

  components: {
    QuoteDocumentPackageBuilderPDFViewer,
    NoDataAvailablePlaceholder,
    QuoteDocumentPackageBuilderSideMenu,
    QuoteDetailCard
  },

  data() {
    return {
      dialog: false,
      loading: false,
      selectedQuote: null as IQuote | null,
      documentSections: [
        {
          title: 'Cover',
          package_documents: [],
          section: QuotePackageSectionEnum.Cover
        },
        {
          title: 'Spec Sheets',
          package_documents: [],
          section: QuotePackageSectionEnum.SpecSheets
        }
      ] as IDocumentSections[],
      selectedSectionIndex: 0,
      selectedDocumentIndex: 0
    };
  },

  computed: {
    /**
     *  check if there's any package documents available to be shown
     */
    showPdfPreview(): boolean {
      return (
        this.documentSections[this.selectedSectionIndex].package_documents
          .length > 0
      );
    }
  },

  mounted() {
    this.mutateDataToSectionDocument();
  },

  methods: {
    mutateDataToSectionDocument() {
      for (let index = 0; index < this.documentSections.length; index++) {
        this.documentSections[
          index
        ].package_documents = this.quotePackage!.package_documents!.filter(
          packageDocument =>
            packageDocument.section == this.documentSections[index].section
        );
      }
    },

    setSelectedQuote(quote: IQuote | null = null) {
      this.selectedQuote = quote;

      // clear document index selection
      this.selectedDocumentIndex = -1;
    },

    setSelectedDocumentSectionIndex(
      sectionIndex: number,
      documentIndex: number
    ) {
      // set quote to null because we are selecting a document
      this.setSelectedQuote(null);

      this.selectedSectionIndex = sectionIndex;
      this.selectedDocumentIndex = documentIndex;
    },

    /**
     *
     * @param sectionIndex
     * shows loading indicator a deselect currently selected document
     */
    setSavingQuotePackageData(sectionIndex: number) {
      this.loading = true;
      this.setSelectedDocumentSectionIndex(sectionIndex, -1);
    },

    setQuotePackageSaveCompletedData(
      sectionIndex: number,
      documentIndex: number
    ) {
      this.loading = false;
      this.setSelectedDocumentSectionIndex(sectionIndex, documentIndex);
    },

    addDocument(section: IDocumentSections, sectionIndex: number) {
      this.$refs.quoteDocumentPackageBuilderSideMenu.addDocument(
        section,
        sectionIndex
      );
    }
  }
});
